import { FilterMatchMode } from 'primereact/api';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { HeaderTable } from './HeaderTable';
import { useEffect, useState } from 'react';
import { GetPricesTable } from '../../../../services/Prices';
import { Toast } from 'primereact/toast';
import { NotificationComponent } from '../../../../components/NotificationComponent';
import { PaymentType } from '../../../../interfaces';
import axios from 'axios';

export const TablePrices = () => {
  const { toast } = NotificationComponent();
  const [arrPrices, setArrPrices] = useState<PaymentType[]>([]);
  const [enabled, setEnabled] = useState(true);
  const [filters, setFilters] = useState({
    name: {
      value: '',
      matchMode: FilterMatchMode.CONTAINS
    },
    'career.description': {
      value: '',
      matchMode: FilterMatchMode.CONTAINS
    },
    'currency.code': {
      value: '',
      matchMode: FilterMatchMode.CONTAINS
    }
  });
  let { loading, reload } = GetPricesTable({ setListPrices: setArrPrices, enabled });

  useEffect(() => {
    reload();
  }, [enabled]);

  const toggleCommand = (pricesTableId: number) => {
    axios
      .post(
        `${process.env.REACT_APP_API_BACKEND}/prices/${pricesTableId}/toggle`,
        {},
        {
          headers: {
            Accept: 'application/json',
            Authorization: `Bearer ${localStorage.getItem('token_hhrr_latam')}`
          }
        }
      )
      .then(() => {
        reload();
      });
  };

  const actionToggle = (rowData: any) => {
    return rowData.enabled ? (
      <Button
        icon='pi pi-eye'
        className='p-button-rounded p-button-text p-button'
        title='Ocultar'
        onClick={() => toggleCommand(rowData.id)}
      />
    ) : (
      <Button
        icon='pi pi-eye-slash'
        className='p-button-rounded p-button-text p-button-danger'
        title='Mostrar'
        onClick={() => toggleCommand(rowData.id)}
      />
    );
  };

  const referenceValueTemplate = (rowData: any) => {
    const pm = rowData.payment_methods?.[0];
    return pm?.pivot?.reference_value ?? '-';
  };

  return (
    <>
      <Toast ref={toast} />
      <DataTable
        value={arrPrices}
        responsiveLayout='stack'
        breakpoint='960px'
        dataKey='id'
        emptyMessage={'No se encontraron datos'}
        rows={15}
        filters={filters}
        onFilter={(e) => setFilters(e.filters as typeof filters)}
        loading={loading}
        filterDisplay='row'
        paginator
        className='shadow-lg shadow-gray-500/30'
        header={<HeaderTable enabled={enabled} setEnabled={setEnabled} />}
      >
        <Column
          field='name'
          filter
          showFilterMenu={false}
          filterPlaceholder={'Buscar por tabla'}
          header={'Tabla de precios'}
          sortable
          style={{ width: '25%' }}
        ></Column>
        <Column field='sis_price_table_id' header={'Id SIS'} sortable style={{ width: '8%' }}></Column>
        <Column
          field={'currency.code'}
          filter
          showFilterMenu={false}
          filterPlaceholder={'Moneda'}
          header={'Moneda'}
          sortable
          style={{ width: '8%' }}
        ></Column>
        <Column field='tuition' header={'Matrícula'} sortable style={{ width: '12%' }}></Column>
        <Column
          header={'Valor de referencia'}
          body={referenceValueTemplate}
          style={{ width: '15%' }}
        ></Column>
        <Column field='pro_value' header={'Valor Pro'} sortable style={{ width: '12%' }}></Column>
        <Column
          body={actionToggle}
          exportable={false}
          style={{ width: '5%' }}
        ></Column>
      </DataTable>
    </>

  );
};
